"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionArgs = void 0;
class ActionArgs {
    constructor(__type, __typeName) {
        this.__type = __type;
        this.__typeName = __typeName;
    }
}
exports.ActionArgs = ActionArgs;
